export const numberValidRegex = (value: string | number) => {
  return value.toString().replace(/[^0-9]/g, "");
};
export const numberValidRegexCurrency = (value: string | number) => {
  if (value) {
    //@ts-ignore
    const numberic = value.replaceAll(",", "");
    const result = numberic.replace(/[^0-9,.]/g, "");
    return Number(result).toLocaleString("en-US");
  } else {
    return "";
  }
};

export const numberCurrency = (value: string | number) => {
  const val = typeof value === "string" ? Number(value) : value;
  return val.toLocaleString("en-US");
};


